// src/components/Background.js
import React from 'react';

const Background = ({ children }) => {
  return (
    <div className="bg-gradient-to-bl from-red-600 to-red-800 p-4 align-middle min-h-screen">
      {children}
    </div>
  );
};

export default Background;